// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".EditorTemplateView {\n  min-width: 100vh;\n  width: 100vh;\n  max-width: 100vh;\n  min-height: 100vh;\n  height: 100vh;\n  max-height: 100vh;\n}", ""]);
// Exports
module.exports = exports;
